import { AVATARS } from '@/utils/CONST';
import { Avatar } from '@/utils/types';
import { useGetList } from 'react-admin';

interface Params {
    filters: { [key: string]: any };
    enabled?: boolean;
    meta?: { api?: 'v1' | 'v2' } | null;
}

interface Output {
    avatars: Avatar[];
    isLoading: boolean;
    refetch: any;
}

const useGetAvatars = ({ filters, enabled = true, meta }: Params): Output => {
    const { data, isLoading, refetch }: any = useGetList(
        AVATARS,
        {
            filter: filters,
            ...(meta != null && { meta }),
        },
        {
            enabled,
        },
    );

    return {
        avatars: data,
        isLoading,
        refetch,
    };
};

export default useGetAvatars;
